<template>
  <div>
    <div class="pgemnt-1">
      <div class="tbs">
        <!-- 搜索内容 -->
        <div class="seekArea">
          <el-form :inline="true" class="demo-form-inline" size="small">
            <el-form-item label="省局">
              <el-input
                size="small"
                v-model="condition.shparentorgname"
                placeholder="输入关键字查询"
                clearable></el-input>
            </el-form-item>
            <el-form-item label="出版单位">
              <el-input size="small" v-model="condition.ydname" placeholder="输入关键字查询" clearable></el-input>
            </el-form-item>
            <el-form-item label="资质" width="170">
              <el-select v-model="condition.ydzz" placeholder="请选择" style="width: 150px" clearable>
                <el-option v-for="item in ydzzOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="状态">
              <el-select v-model="condition.ydstatus" placeholder="请选择" style="width: 100px" clearable>
                <el-option v-for="item in ydstatusOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-button type="primary" style="justify-content: end" @click="search()" size="small">查询</el-button>
            <el-button type="primary" style="justify-content: end" @click="exportTable()" size="small">导出</el-button>
          </el-form>
        </div>
        <!-- 显示表格 -->
        <el-table :data="showArr" style="width: 100%" @sort-change="sortChanged">
          <el-table-column label="省局" prop="shparentorgname" width="220" sortable> </el-table-column>
          <el-table-column label="出版单位" prop="ydname">
            <template slot="header" slot-scope="scope">
              {{ "出版单位" }}
              {{ `（合计：${totalCount}）` }}
            </template>
          </el-table-column>
          <el-table-column label="资质" prop="ydzzName" width="280">
            <template slot="header" slot-scope="scope">
              {{ colYdzzName }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="状态" prop="ydstatusName" width="180">
            <template slot="header" slot-scope="scope">
              {{ "状态" }}
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { getPublishList } from "@/api/pgMent/publishMent";
import moment from "moment";
const XLSX = require("xlsx");

export default {
  data() {
    return {
      tableData: [],
      storeArr: [],
      showArr: [],
      totalCount: "0",

      condition: {
        shparentorgname: "",
        ydname: "",
        ydzz: "",
        ydstatus: "",
      },

      colYdzzName: "资质",

      ydzzOptions: [
        { label: "音像", value: "0" },
        { label: "电子", value: "1" },
        { label: "连续型电子出版物", value: "2" },
        { label: "音像+电子", value: "0,1" },
      ],
      ydstatusOptions: [
        { label: "正常", value: "2" },
        { label: "注销", value: "1" },
      ],
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    getList: function () {
      let that = this;
      getPublishList({}).then((response) => {
        // console.log("getPublishList", response);
        that.tableData = response.data;
        that.formateDat(that.tableData);
        // console.log("that.showArr", that.storeArr);
        that.showFormate("init");
      });
    },

    goDeeper: function (dats) {
      // console.log(dats);
    },
    sortChanged: function (params) {
      console.log(params);
    },
    formateDat: function (dats, inx) {
      this.storeArr = [];
      for (let i in dats) {
        let Item = dats[i];
        // 格式化资质
        var values = Item.ydzz.split(",");
        var ydzzName = "";
        for (var value of values) {
          switch (value) {
            case "0":
              ydzzName += ",音像";
              break;
            case "1":
              ydzzName += ",电子";
              break;
            case "2":
              ydzzName += ",连续型电子出版物";
              break;
            default:
              ydzzName += "," + value;
              break;
          }
        }
        if (ydzzName.length > 0) {
          ydzzName = ydzzName.substring(1);
        }
        Item.ydzzName = ydzzName;

        // 格式化状态
        var ydstatusName = "";
        if (Item.ydstatus == "1") {
          ydstatusName = "注销";
        } else {
          ydstatusName = "正常";
        }
        Item.ydstatusName = ydstatusName;
        this.storeArr.push(Item);
      }
    },

    arrEquires: function (arr1, arr2) {
      let eqs = true;
      for (let i in arr1) {
        if (arr1[i] != arr2[i]) {
          eqs = false;
          break;
        }
      }

      return eqs;
    },
    showFormate: function (state, iArr) {
      let tempArr = [];
      for (let i in this.storeArr) {
        let item = this.storeArr[i];
        if (state == "init") {
          tempArr.push(item);
        }
      }
      this.showArr = tempArr;
      this.totalCount = this.showArr.length;
    },
    setQueryVisible: function (scope) {
      console.log(scope);
    },
    search: function () {
      let that = this;
      console.log(that.condition);
      getPublishList(that.condition).then((response) => {
        that.colYdzzName = that.condition.ydzz == "2" ? "连续型电子出版物" : "资质";
        that.tableData = response.data;
        that.formateDat(that.tableData);
        that.showFormate("init");
      });
    },
    exportTable: async function () {
      var columns = { shparentorgname: "省局", ydname: "出版单位", ydzzName: this.colYdzzName };
      let cellWidths = [{ wpx: 180 }, { wpx: 300 }, { wpx: 80 }];
      var list = [];
      for (var i in this.showArr) {
        var po = this.showArr[i];
        var data = {};
        for (var key in columns) {
          data[columns[key]] = po[key];
        }
        list.push(data);
      }
      var filename = `出版单位一览_${moment()}.xlsx`;
      var opts = Object.values(columns);
      var wsname = "Sheet1";
      const wb = XLSX.utils.book_new();
      const ws = await XLSX.utils.json_to_sheet(list, opts);
      ws["!cols"] = cellWidths;
      XLSX.utils.book_append_sheet(wb, ws, wsname);
      await XLSX.writeFile(wb, `${filename}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.pgemnt-1 {
  padding: 6px 30px;
}

.el-table {
  margin-top: 0px;
}

.pgemnt-1 .goDeeper {
  cursor: pointer;
}

.pgemnt-1-dag .el-dialog__header {
  padding: 20px 18px 25px;
}

.pgemnt-1-dag .el-dialog__body {
  padding: 0px 30px;
  margin-bottom: 12px;
}

.pgemnt-1-dag .el-dialog__footer {
  padding-bottom: 30px;
}

.pgemnt-1-dag table {
  width: 100%;
  margin-top: 12px;
}

.pgemnt-1-dag table td {
  padding-bottom: 12px;
}

.pgemnt-1-dag .inContent {
  padding-right: 12px;
}

.pgemnt-1 .inpName {
  text-align: right;
  width: 90px;
  padding-right: 6px;
}

.pgemnt-1 .inpGup {
  margin-bottom: 12px;
  height: 45px;
  background: salmon;
}

.pgemnt-1 .newAdd {
  width: 90px;
}
</style>



// WEBPACK FOOTER //
// publishMent.vue?879476ce